import {
  LIST_EXAMINATION_RESULT_REQUEST,
  LIST_EXAMINATION_RESULT_SUCCESS,
  LIST_EXAMINATION_RESULT_FAIL,
  FINISH_EXAMINATION_RESULT_REQUEST,
  FINISH_EXAMINATION_RESULT_SUCCESS,
  FINISH_EXAMINATION_RESULT_FAIL,
  RESEND_ORDER_LIS_EXAMINATION_RESULT_REQUEST,
  RESEND_ORDER_LIS_EXAMINATION_RESULT_SUCCESS,
  RESEND_ORDER_LIS_EXAMINATION_RESULT_FAIL,
  LIST_EXAMINATION_RESULT_PATIENT_EXAMINATION_SUMMARY_REQUEST,
  LIST_EXAMINATION_RESULT_PATIENT_EXAMINATION_SUMMARY_SUCCESS,
  LIST_EXAMINATION_RESULT_PATIENT_EXAMINATION_SUMMARY_FAIL,
  TAX_ACTIVIRY_EXAMINATION_RESULT_PATIENT_EXAMINATION_REQUEST,
  TAX_ACTIVIRY_EXAMINATION_RESULT_PATIENT_EXAMINATION_SUCCESS,
  TAX_ACTIVIRY_EXAMINATION_RESULT_PATIENT_EXAMINATION_FAIL,
  DETAIL_PATIENT_EXAMINATION_RESULT_PATIENT_EXAMINATION_REQUEST,
  DETAIL_PATIENT_EXAMINATION_RESULT_PATIENT_EXAMINATION_SUCCESS,
  DETAIL_PATIENT_EXAMINATION_RESULT_PATIENT_EXAMINATION_FAIL,
  LIST_MCU_PATIENT_RESULT_SUMMARY_REQUEST,
  LIST_MCU_PATIENT_RESULT_SUMMARY_SUCCESS,
  LIST_MCU_PATIENT_RESULT_SUMMARY_FAIL,
  DETAIL_PATIENT_EXAMINATION_RESULT_PATIENT_TEETH_REQUEST,
  DETAIL_PATIENT_EXAMINATION_RESULT_PATIENT_TEETH_SUCCESS,
  DETAIL_PATIENT_EXAMINATION_RESULT_PATIENT_TEETH_FAIL,
  ACTION_SUBMIT_PATIENT_EXAMINATION_RESULT_PATIENT_EXAMINATION_REQUEST,
  ACTION_SUBMIT_PATIENT_EXAMINATION_RESULT_PATIENT_EXAMINATION_SUCCESS,
  ACTION_SUBMIT_PATIENT_EXAMINATION_RESULT_PATIENT_EXAMINATION_FAIL,
  UPDATE_EXAMINATION_RESULT_PATIENT_EXAMINATION_REQUEST,
  UPDATE_EXAMINATION_RESULT_PATIENT_EXAMINATION_SUCCESS,
  UPDATE_EXAMINATION_RESULT_PATIENT_EXAMINATION_FAIL,
  CANCEL_EXAMINATION_RESULT_PATIENT_EXAMINATION_REQUEST,
  CANCEL_EXAMINATION_RESULT_PATIENT_EXAMINATION_SUCCESS,
  CANCEL_EXAMINATION_RESULT_PATIENT_EXAMINATION_FAIL,
  ACTION_PATIENT_EXAMINATION_RESULT_PATIENT_EXAMINATION_REQUEST,
  ACTION_PATIENT_EXAMINATION_RESULT_PATIENT_EXAMINATION_SUCCESS,
  ACTION_PATIENT_EXAMINATION_RESULT_PATIENT_EXAMINATION_FAIL,
  TYPE_ACTION_EXAMINATION_RESULT_PATIENT_EXAMINATION,
  RE_ITEM_EXAMINATION_RESULT_PATIENT_EXAMINATION_REQUEST,
  RE_ITEM_EXAMINATION_RESULT_PATIENT_EXAMINATION_SUCCESS,
  RE_ITEM_EXAMINATION_RESULT_PATIENT_EXAMINATION_FAIL,
  GENERATE_ITEM_EXAMINATION_RESULT_PATIENT_EXAMINATION_REQUEST,
  GENERATE_ITEM_EXAMINATION_RESULT_PATIENT_EXAMINATION_SUCCESS,
  GENERATE_ITEM_EXAMINATION_RESULT_PATIENT_EXAMINATION_FAIL,
  SUBMIT_EXAMINATION_RESULT_PATIENT_EXAMINATION_REQUEST,
  SUBMIT_EXAMINATION_RESULT_PATIENT_EXAMINATION_SUCCESS,
  SUBMIT_EXAMINATION_RESULT_PATIENT_EXAMINATION_FAIL,
  HISTORY_PATIENT_EXAMINATION_RESULT_PATIENT_EXAMINATION_REQUEST,
  HISTORY_PATIENT_EXAMINATION_RESULT_PATIENT_EXAMINATION_SUCCESS,
  HISTORY_PATIENT_EXAMINATION_RESULT_PATIENT_EXAMINATION_FAIL,
  PRINT_PREVIEW_EXAMINATION_RESULT_PATIENT_EXAMINATION_REQUEST,
  PRINT_PREVIEW_EXAMINATION_RESULT_PATIENT_EXAMINATION_SUCCESS,
  PRINT_PREVIEW_EXAMINATION_RESULT_PATIENT_EXAMINATION_FAIL,
  CREATE_NEW_RESULT_EXAMINATION_RESULT_PATIENT_EXAMINATION_REQUEST,
  CREATE_NEW_RESULT_EXAMINATION_RESULT_PATIENT_EXAMINATION_SUCCESS,
  CREATE_NEW_RESULT_EXAMINATION_RESULT_PATIENT_EXAMINATION_FAIL,
  LOG_TASK_ACTIVITY_REQUEST,
  LOG_TASK_ACTIVITY_SUCCESS,
  LOG_TASK_ACTIVITY_FAIL,
  SUBMIT_TASK_EXAMINATION_RESULT_PATIENT_REQUEST,
  SUBMIT_TASK_EXAMINATION_RESULT_PATIENT_SUCCESS,
  SUBMIT_TASK_EXAMINATION_RESULT_PATIENT_FAIL,
  IMPORT_REVIEW_RESULT_REQUEST,
  IMPORT_REVIEW_RESULT_SUCCESS,
  IMPORT_REVIEW_RESULT_FAIL,
  LIST_IMPORT_REVIEW_RESULT_REQUEST,
  LIST_IMPORT_REVIEW_RESULT_SUCCESS,
  LIST_IMPORT_REVIEW_RESULT_FAIL,
  LIST_DETAIL_IMPORT_REVIEW_RESULT_REQUEST,
  LIST_DETAIL_IMPORT_REVIEW_RESULT_SUCCESS,
  LIST_DETAIL_IMPORT_REVIEW_RESULT_FAIL,
  DETAIL_IMPORT_REVIEW_RESULT_REQUEST,
  DETAIL_IMPORT_REVIEW_RESULT_SUCCESS,
  DETAIL_IMPORT_REVIEW_RESULT_FAIL,
  EXPORT_IMPORT_REVIEW_RESULT_REQUEST,
  EXPORT_IMPORT_REVIEW_RESULT_SUCCESS,
  EXPORT_IMPORT_REVIEW_RESULT_FAIL,
  DOWNLOAD_TEMPLATE_IMPORT_REVIEW_RESULT_REQUEST,
  DOWNLOAD_TEMPLATE_IMPORT_REVIEW_RESULT_SUCCESS,
  DOWNLOAD_TEMPLATE_IMPORT_REVIEW_RESULT_FAIL,
  LIST_EXAMINATION_ATTACHMENT_REQUEST,
  LIST_EXAMINATION_ATTACHMENT_SUCCESS,
  LIST_EXAMINATION_ATTACHMENT_FAIL,
  DELETE_ATTACHMENT_MCU_REQUEST,
  DELETE_ATTACHMENT_MCU_SUCCESS,
  DELETE_ATTACHMENT_MCU_FAIL,
  SELECT_SUMMARY_RECOMMENDATION_REQUEST,
  SELECT_SUMMARY_RECOMMENDATION_SUCCESS,
  SELECT_SUMMARY_RECOMMENDATION_FAIL,
  EXPORT_VALIDATION_RESULT_REQUEST,
  EXPORT_VALIDATION_RESULT_SUCCESS,
  EXPORT_VALIDATION_RESULT_FAIL,
  LIST_EXPORT_VALIDATION_RESULT_REQUEST,
  LIST_EXPORT_VALIDATION_RESULT_SUCCESS,
  LIST_EXPORT_VALIDATION_RESULT_FAIL,
  DOWNLOAD_EXPORT_VALIDATION_RESULT_REQUEST,
  DOWNLOAD_EXPORT_VALIDATION_RESULT_SUCCESS,
  DOWNLOAD_EXPORT_VALIDATION_RESULT_FAIL,
  SUBMIT_ALL_EXAMINATION_RESULT_REQUEST,
  SUBMIT_ALL_EXAMINATION_RESULT_SUCCESS,
  SUBMIT_ALL_EXAMINATION_RESULT_FAIL,
  VALIDATION_BULK_UPLOAD_FILE_REQUEST,
  VALIDATION_BULK_UPLOAD_FILE_SUCCESS,
  VALIDATION_BULK_UPLOAD_FILE_FAIL,
  CANCEL_SUBMIT_ALL_EXAMINATION_RESULT_REQUEST,
  CANCEL_SUBMIT_ALL_EXAMINATION_RESULT_SUCCESS,
  CANCEL_SUBMIT_ALL_EXAMINATION_RESULT_FAIL,
  EXPORT_REVIEW_RESULT_REQUEST,
  EXPORT_REVIEW_RESULT_SUCCESS,
  EXPORT_REVIEW_RESULT_FAIL,
  EXPORT_TASK_ACTIVITY_REQUEST,
  EXPORT_TASK_ACTIVITY_SUCCESS,
  EXPORT_TASK_ACTIVITY_FAIL,
  INCLUDE_RESUME_EXAMINATION_RESULT_REQUEST,
  INCLUDE_RESUME_EXAMINATION_RESULT_SUCCESS,
  INCLUDE_RESUME_EXAMINATION_RESULT_FAIL,
  HISTORY_LOGS_REQUEST,
  HISTORY_LOGS_SUCCESS,
  HISTORY_LOGS_FAIL,
  UPDATE_NOTE_EXAMINATION_RESULT_REQUEST,
  UPDATE_NOTE_EXAMINATION_RESULT_SUCCESS,
  UPDATE_NOTE_EXAMINATION_RESULT_FAIL,
  BULK_PUBLISH_NOT_PUBLISH_EXAMINATION_RESULT_REQUEST,
  BULK_PUBLISH_NOT_PUBLISH_EXAMINATION_RESULT_SUCCESS,
  BULK_PUBLISH_NOT_PUBLISH_EXAMINATION_RESULT_FAIL,
  BULK_REFERENCE_EXAMINATION_RESULT_REQUEST,
  BULK_REFERENCE_EXAMINATION_RESULT_SUCCESS,
  BULK_REFERENCE_EXAMINATION_RESULT_FAIL
} from '../../constants/examination-results'

const initialState = {
  examinationResultList: [],
  pageable: {
    page: 1,
    size: 10
  },
  pageableListDetailImportReview: {
    page: 1,
    size: 10
  },
  examinationItems: [],
  loadingResendOrderLis: false,
  loadingBulkPublishNotPublish: false,
  patient: {},
  taxActivities: [],
  loading: false,
  loadingFinish: false,
  loadingAttachment: false,
  logActivity: {},
  loadingSubmit: false,
  loadingCancelSubmitAll: false,
  error: null,
  loadingTaxActivity: false,
  loadingDelete: false,
  teeth: {},
  resultSummary: [],
  errorTaxActivity: null,
  loadingDetail: false,
  errorDetail: null,
  typeActionColumn: '',
  examinationItemsAttachment: [],
  PHYSICAL: [],
  attachmentPHYSICAL: [],
  LABORATORY: [],
  attachmentLABORATORY: [],
  HISTORY: [],
  attachmentHISTORY: [],
  RADIOLOGY: [],
  attachmentRADIOLOGY: [],
  CARDIOLOGY: [],
  attachmentCARDIOLOGY: [],
  OTHERS: [],
  attachmentOTHERS: [],
  SPIROMETRY: [],
  attachmentSPIROMETRY: [],
  AUDIOMETRY: [],
  attachmentAUDIOMETRY: [],
  loadingImport: false,
  loadingImportReview: false,
  loadingExport: false,
  loadingDownloadTemplate: false,
  loadingDetailImport: false,
  loadingDetailImportReview: false,
  importReviewList: [],
  importReviewDetail: {},
  importReviewDetailList: [],
  validateFileResult: [],
  loadingValidation: false,
  loadingLog: false,
  loadingIncludeResume: false,
  historyLogs: [],
  loadingHistoryLogs: false,
  loadingNote: false,
  loadingBulkReference: false,
  retryAttempPreview: 0
}

const examinationResultReducer = (state = initialState, action) => {
  switch (action.type) {
    case SUBMIT_EXAMINATION_RESULT_PATIENT_EXAMINATION_REQUEST:
      return {
        ...state,
        loadingSubmit: true
      }
    case SUBMIT_EXAMINATION_RESULT_PATIENT_EXAMINATION_FAIL:
    case SUBMIT_EXAMINATION_RESULT_PATIENT_EXAMINATION_SUCCESS:
      return {
        ...state,
        loadingSubmit: false
      }
    case LIST_EXAMINATION_RESULT_REQUEST:
      return {
        ...state,
        loading: true
      }
    case LIST_EXAMINATION_RESULT_SUCCESS:
      return {
        ...state,
        loading: false,
        examinationResultList: action.payload,
        pageable: action.pageable,
        error: null
      }
    case LIST_EXAMINATION_RESULT_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload
      }
    case FINISH_EXAMINATION_RESULT_REQUEST:
      return {
        ...state,
        loadingFinish: true
      }
    case FINISH_EXAMINATION_RESULT_SUCCESS:
      return {
        ...state,
        loadingFinish: false,
        error: null
      }
    case FINISH_EXAMINATION_RESULT_FAIL:
      return {
        ...state,
        loadingFinish: false,
        error: action.payload
      }
    case RESEND_ORDER_LIS_EXAMINATION_RESULT_REQUEST:
      return {
        ...state,
        loadingResendOrderLis: true
      }
    case RESEND_ORDER_LIS_EXAMINATION_RESULT_SUCCESS:
      return {
        ...state,
        loadingResendOrderLis: false,
        error: null
      }
    case RESEND_ORDER_LIS_EXAMINATION_RESULT_FAIL:
      return {
        ...state,
        loadingResendOrderLis: false,
        error: action.payload
      }
    case LIST_EXAMINATION_RESULT_PATIENT_EXAMINATION_SUMMARY_REQUEST:
      return {
        ...state,
        loading: true,
        examinationItems: [],
        [action.code]: []
      }
    case LIST_EXAMINATION_RESULT_PATIENT_EXAMINATION_SUMMARY_SUCCESS:
      return {
        ...state,
        loading: false,
        examinationItems: action.payload,
        error: null,
        [action.code]: action.payload
      }
    case LIST_EXAMINATION_RESULT_PATIENT_EXAMINATION_SUMMARY_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
        examinationItems: action?.dummy
      }
    case LIST_EXAMINATION_ATTACHMENT_REQUEST:
      return {
        ...state,
        loadingAttachment: true,
        examinationItemsAttachment: [],
        [`attachment${action.code}`]: []
      }
    case LIST_EXAMINATION_ATTACHMENT_SUCCESS:
      return {
        ...state,
        loadingAttachment: false,
        examinationItemsAttachment: action.payload,
        error: null,
        [`attachment${action.code}`]: action.payload
      }
    case LIST_EXAMINATION_ATTACHMENT_FAIL:
      return {
        ...state,
        loadingAttachment: false,
        error: action.payload
      }
    case TAX_ACTIVIRY_EXAMINATION_RESULT_PATIENT_EXAMINATION_REQUEST:
      return {
        ...state,
        loadingTaxActivity: true
      }
    case TAX_ACTIVIRY_EXAMINATION_RESULT_PATIENT_EXAMINATION_SUCCESS:
      return {
        ...state,
        loadingTaxActivity: false,
        taxActivities: action.payload,
        errorTaxActivity: null
      }
    case TAX_ACTIVIRY_EXAMINATION_RESULT_PATIENT_EXAMINATION_FAIL:
      return {
        ...state,
        loadingTaxActivity: false,
        errorTaxActivity: action.payload,
        taxActivities: action?.dummy
      }
    case DETAIL_PATIENT_EXAMINATION_RESULT_PATIENT_EXAMINATION_REQUEST:
      return {
        ...state,
        loadingDetail: true,
        patient: {},
        examinationItems: [],
        taxActivities: [],
        PHYSICAL: [],
        LABORATORY: [],
        HISTORY: [],
        RADIOLOGY: [],
        CARDIOLOGY: [],
        OTHERS: [],
        teeth: {}
      }
    case DETAIL_PATIENT_EXAMINATION_RESULT_PATIENT_EXAMINATION_SUCCESS:
      return {
        ...state,
        loadingDetail: false,
        patient: action.payload,
        errorDetail: null
      }
    case DETAIL_PATIENT_EXAMINATION_RESULT_PATIENT_EXAMINATION_FAIL:
      return {
        ...state,
        loadingDetail: false,
        errorDetail: action.payload,
        patient: action?.dummy
      }
    case LIST_MCU_PATIENT_RESULT_SUMMARY_REQUEST:
      return {
        ...state,
        loading: true
      }
    case LIST_MCU_PATIENT_RESULT_SUMMARY_SUCCESS:
      return {
        ...state,
        loading: false,
        resultSummary: action.payload,
        error: null
      }
    case LIST_MCU_PATIENT_RESULT_SUMMARY_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
        resultSummary: action?.dummy
      }
    case DETAIL_PATIENT_EXAMINATION_RESULT_PATIENT_TEETH_REQUEST:
      return {
        ...state,
        loadingDetailTeeth: true
      }
    case DETAIL_PATIENT_EXAMINATION_RESULT_PATIENT_TEETH_SUCCESS:
      return {
        ...state,
        loadingDetailTeeth: false,
        teeth: action.payload,
        errorDetailTeeth: null
      }
    case DETAIL_PATIENT_EXAMINATION_RESULT_PATIENT_TEETH_FAIL:
      return {
        ...state,
        loadingDetailTeeth: false,
        errorDetailTeeth: action.payload,
        teeth: action?.dummy
      }
    case UPDATE_EXAMINATION_RESULT_PATIENT_EXAMINATION_REQUEST:
      return {
        ...state,
        loadingUpdate: true
      }
    case UPDATE_EXAMINATION_RESULT_PATIENT_EXAMINATION_SUCCESS:
      return {
        ...state,
        loadingUpdate: false,
        errorUpdate: null
      }
    case UPDATE_EXAMINATION_RESULT_PATIENT_EXAMINATION_FAIL:
      return {
        ...state,
        loadingUpdate: false,
        errorUpdate: action.payload
      }
    case ACTION_SUBMIT_PATIENT_EXAMINATION_RESULT_PATIENT_EXAMINATION_REQUEST:
      return {
        ...state,
        loadingActionSubmit: true
      }
    case ACTION_SUBMIT_PATIENT_EXAMINATION_RESULT_PATIENT_EXAMINATION_SUCCESS:
      return {
        ...state,
        loadingActionSubmit: false,
        errorActionSubmit: null
      }
    case ACTION_SUBMIT_PATIENT_EXAMINATION_RESULT_PATIENT_EXAMINATION_FAIL:
      return {
        ...state,
        loadingActionSubmit: false,
        errorActionSubmit: action.payload
      }
    case CANCEL_EXAMINATION_RESULT_PATIENT_EXAMINATION_REQUEST:
      return {
        ...state,
        loadingCancel: true
      }
    case CANCEL_EXAMINATION_RESULT_PATIENT_EXAMINATION_SUCCESS:
      return {
        ...state,
        loadingCancel: false,
        errorCancel: null
      }
    case CANCEL_EXAMINATION_RESULT_PATIENT_EXAMINATION_FAIL:
      return {
        ...state,
        loadingCancel: false,
        errorCancel: action.payload
      }
    case DELETE_ATTACHMENT_MCU_REQUEST:
      return {
        ...state,
        loadingDelete: true
      }
    case DELETE_ATTACHMENT_MCU_SUCCESS:
      return {
        ...state,
        loadingDelete: false,
        errorCancel: null
      }
    case DELETE_ATTACHMENT_MCU_FAIL:
      return {
        ...state,
        loadingDelete: false,
        errorCancel: action.payload
      }
    case ACTION_PATIENT_EXAMINATION_RESULT_PATIENT_EXAMINATION_REQUEST:
      return {
        ...state,
        loadingAction: true
      }
    case ACTION_PATIENT_EXAMINATION_RESULT_PATIENT_EXAMINATION_SUCCESS:
      return {
        ...state,
        loadingAction: false,
        errorPending: null
      }
    case ACTION_PATIENT_EXAMINATION_RESULT_PATIENT_EXAMINATION_FAIL:
      return {
        ...state,
        loadingAction: false,
        errorPending: action.payload
      }
    case TYPE_ACTION_EXAMINATION_RESULT_PATIENT_EXAMINATION:
      return {
        ...state,
        typeActionColumn: action.payload
      }
    case LOG_TASK_ACTIVITY_REQUEST:
      return {
        ...state,
        loadingLog: true,
        logActivity: {}
      }
    case LOG_TASK_ACTIVITY_SUCCESS:
      return {
        ...state,
        loadingLog: false,
        logActivity: action.payload
      }
    case LOG_TASK_ACTIVITY_FAIL: {
      return {
        ...state,
        loadingLog: false
      }
    }
    case RE_ITEM_EXAMINATION_RESULT_PATIENT_EXAMINATION_REQUEST:
      return {
        ...state,
        loadingReItem: true
      }
    case RE_ITEM_EXAMINATION_RESULT_PATIENT_EXAMINATION_SUCCESS:
      return {
        ...state,
        loadingReItem: false,
        errorReItem: null
      }
    case RE_ITEM_EXAMINATION_RESULT_PATIENT_EXAMINATION_FAIL:
      return {
        ...state,
        loadingReItem: false,
        errorReItem: action.payload
      }
    case GENERATE_ITEM_EXAMINATION_RESULT_PATIENT_EXAMINATION_REQUEST:
      return {
        ...state,
        loadingGenerate: true
      }
    case GENERATE_ITEM_EXAMINATION_RESULT_PATIENT_EXAMINATION_SUCCESS:
      return {
        ...state,
        loadingGenerate: false,
        errorGenerate: null
      }
    case GENERATE_ITEM_EXAMINATION_RESULT_PATIENT_EXAMINATION_FAIL:
      return {
        ...state,
        loadingGenerate: false,
        errorGenerate: action.payload
      }
    case HISTORY_PATIENT_EXAMINATION_RESULT_PATIENT_EXAMINATION_REQUEST:
      return {
        ...state,
        loadingHistory: true
      }
    case HISTORY_PATIENT_EXAMINATION_RESULT_PATIENT_EXAMINATION_SUCCESS:
      return {
        ...state,
        loadingHistory: false,
        historyLog: action.payload,
        errorHistory: null
      }
    case HISTORY_PATIENT_EXAMINATION_RESULT_PATIENT_EXAMINATION_FAIL:
      return {
        ...state,
        loadingHistory: false,
        errorHistory: action.payload,
        historyLog: action?.dummy
      }
    case PRINT_PREVIEW_EXAMINATION_RESULT_PATIENT_EXAMINATION_REQUEST:
      return {
        ...state,
        loadingPrintPreview: true,
        retryAttempPreview: 0
      }
    case PRINT_PREVIEW_EXAMINATION_RESULT_PATIENT_EXAMINATION_SUCCESS:
      return {
        ...state,
        loadingPrintPreview: false,
        errorPrintPreview: null,
        retryAttempPreview: 0
      }
    case PRINT_PREVIEW_EXAMINATION_RESULT_PATIENT_EXAMINATION_FAIL:
      return {
        ...state,
        loadingPrintPreview: false,
        errorPrintPreview: action.payload,
        retryAttempPreview: 0
      }
    case 'COUNT_REPLY_PRINT_PREIEW':
      return {
        ...state,
        retryAttempPreview: action?.payload
      }
    case CREATE_NEW_RESULT_EXAMINATION_RESULT_PATIENT_EXAMINATION_REQUEST:
      return {
        ...state,
        loadingCreateNewResult: true
      }
    case CREATE_NEW_RESULT_EXAMINATION_RESULT_PATIENT_EXAMINATION_SUCCESS:
      return {
        ...state,
        loadingCreateNewResult: false,
        errorCreateNewResult: null
      }
    case CREATE_NEW_RESULT_EXAMINATION_RESULT_PATIENT_EXAMINATION_FAIL:
      return {
        ...state,
        loadingCreateNewResult: false,
        errorCreateNewResult: action.payload
      }
    case SUBMIT_TASK_EXAMINATION_RESULT_PATIENT_REQUEST:
      return {
        ...state,
        loadingActionSubmit: true
      }
    case SUBMIT_TASK_EXAMINATION_RESULT_PATIENT_SUCCESS:
      return {
        ...state,
        loadingActionSubmit: false,
        error: null
      }
    case SUBMIT_TASK_EXAMINATION_RESULT_PATIENT_FAIL:
      return {
        ...state,
        loadingActionSubmit: false,
        error: action?.payload
      }
    case IMPORT_REVIEW_RESULT_REQUEST:
      return {
        ...state,
        loadingImport: true
      }
    case IMPORT_REVIEW_RESULT_SUCCESS:
      return {
        ...state,
        loadingImport: false,
        error: null
      }
    case IMPORT_REVIEW_RESULT_FAIL:
      return {
        ...state,
        loadingImport: false,
        error: action?.payload
      }
    case LIST_IMPORT_REVIEW_RESULT_REQUEST:
      return {
        ...state,
        loadingImportReview: true
      }
    case LIST_IMPORT_REVIEW_RESULT_SUCCESS:
      return {
        ...state,
        loadingImportReview: false,
        importReviewList: action?.payload,
        pageable: action?.pageable,
        error: null
      }
    case LIST_IMPORT_REVIEW_RESULT_FAIL:
      return {
        ...state,
        loadingImportReview: false,
        error: action?.payload,
        importReviewList: action?.dummy
      }
    case LIST_DETAIL_IMPORT_REVIEW_RESULT_REQUEST:
      return {
        ...state,
        loadingDetailImportReview: true
      }
    case LIST_DETAIL_IMPORT_REVIEW_RESULT_SUCCESS:
      return {
        ...state,
        loadingDetailImportReview: false,
        importReviewDetailList: action?.payload,
        pageableListDetailImportReview: action?.pageable,
        error: null
      }
    case LIST_DETAIL_IMPORT_REVIEW_RESULT_FAIL:
      return {
        ...state,
        loadingDetailImportReview: false,
        error: action?.payload,
        importReviewDetailList: action?.dummy
      }
    case DETAIL_IMPORT_REVIEW_RESULT_REQUEST:
      return {
        ...state,
        loadingDetailImport: true
      }
    case DETAIL_IMPORT_REVIEW_RESULT_SUCCESS:
      return {
        ...state,
        loadingDetailImport: false,
        importReviewDetail: action?.payload,
        error: null
      }
    case DETAIL_IMPORT_REVIEW_RESULT_FAIL:
      return {
        ...state,
        loadingDetailImport: false,
        error: action?.payload,
        importReviewDetail: action?.dummy
      }
    case EXPORT_IMPORT_REVIEW_RESULT_REQUEST:
      return {
        ...state,
        loadingExport: true
      }
    case EXPORT_IMPORT_REVIEW_RESULT_SUCCESS:
      return {
        ...state,
        loadingExport: false,
        error: null
      }
    case EXPORT_IMPORT_REVIEW_RESULT_FAIL:
      return {
        ...state,
        loadingExport: false,
        error: action?.payload
      }
    case DOWNLOAD_TEMPLATE_IMPORT_REVIEW_RESULT_REQUEST:
      return {
        ...state,
        loadingDownloadTemplate: true
      }
    case DOWNLOAD_TEMPLATE_IMPORT_REVIEW_RESULT_SUCCESS:
      return {
        ...state,
        loadingDownloadTemplate: false,
        error: null
      }
    case DOWNLOAD_TEMPLATE_IMPORT_REVIEW_RESULT_FAIL:
      return {
        ...state,
        loadingDownloadTemplate: false,
        error: action?.payload
      }
    case SELECT_SUMMARY_RECOMMENDATION_REQUEST:
      return {
        ...state,
        summaryRecommendation: [],
        loadingSelectResume: true
      }
    case SELECT_SUMMARY_RECOMMENDATION_SUCCESS:
      // ** Combine data summary to value input summary input
      const dataSummary = action.payload?.summary
      const dataSummaryRecommendation = action.payload?.recommendation

      // ** Get Element Summary
      const summary = document.getElementById('summary')

      // ** Get Element Recommendation
      const recommendation = document.getElementById('recomendation')

      // ** Combine value summary text area
      // ** getValue summary input text area
      const valueSummaryBefore = summary?.value
      const valueSummaryAfter = `${valueSummaryBefore}${
        !valueSummaryBefore ? '' : '\n'
      }${dataSummary}`

      // ** Combine value recommendation
      const valueRecommendationBefore = recommendation?.value
      const valueRecommendationAfter = `${valueRecommendationBefore}${
        !valueRecommendationBefore ? '' : '\n'
      }${dataSummaryRecommendation}`

      // ** dengerous html &nbsp; to space
      const valueSummaryAfterReplace = valueSummaryAfter.replace(/&nbsp;/g, ' ')
      const valueRecommendationAfterReplace = valueRecommendationAfter.replace(
        /&nbsp;/g,
        ' '
      )

      // ** Set value summary & recommendation text area
      if (!state?.examinationItems?.summary?.prepared) {
        summary.value = valueSummaryAfterReplace
        summary.innerHTML = valueSummaryAfterReplace
        summary.innerText = valueSummaryAfterReplace
        summary.textContent = valueSummaryAfterReplace
      }

      if (!state?.examinationItems?.recommendation?.prepared) {
        recommendation.value = valueRecommendationAfterReplace
        recommendation.innerHTML = valueRecommendationAfterReplace
        recommendation.innerText = valueRecommendationAfterReplace
        recommendation.textContent = valueRecommendationAfterReplace
      }

      // ** Get element class container-examination-button
      const containerExaminationButton = document.querySelector(
        '.container-examination-button'
      )

      // ** get Children element
      const childrenElement = containerExaminationButton?.children

      // ** Find class btn btn-primary in children element
      const btnPrimary = [...childrenElement].find((item) =>
        item.classList.contains('btn-primary')
      )
      const examinationButton = btnPrimary.textContent.toLowerCase()

      const examinationItemsNew = { ...state?.examinationItems }

      const summaryState = examinationItemsNew?.summary[examinationButton]
      const recommendationState =
        examinationItemsNew?.recommendation[examinationButton]

      // ** Get Element Summary
      const summaryAfterAppend = document.getElementById('summary')

      // ** Get Element Recommendation
      const recommendationAfterAppend = document.getElementById('recomendation')

      // ** Combine value summary state
      const valueSummaryStateBefore = `${summaryState || ''}${
        !summaryState ? '' : '\n'
      }${dataSummary}`
      const valueSummaryStateAfter = valueSummaryStateBefore.replace(
        /&nbsp;/g,
        ' '
      )
      if (!state?.examinationItems?.summary?.prepared) {
        examinationItemsNew.summary[examinationButton] =
          summaryAfterAppend.value
      }

      // ** Combine value recommendation state
      const valueRecommendationStateBefore = `${recommendationState || ''}${
        !recommendationState ? '' : '\n'
      }${dataSummaryRecommendation}`
      const valueRecommendationStateAfter =
        valueRecommendationStateBefore.replace(/&nbsp;/g, ' ')
      if (!state?.examinationItems?.recommendation?.prepared) {
        examinationItemsNew.recommendation[examinationButton] =
          recommendationAfterAppend.value
      }
      return {
        ...state,
        summaryRecommendation: action.payload,
        loadingSelectResume: false,
        examinationItems: examinationItemsNew,
        error: null
      }
    case SELECT_SUMMARY_RECOMMENDATION_FAIL:
      return {
        ...state,
        summaryRecommendation: action?.dummy,
        loadingSelectResume: false,
        error: action?.payload
      }
    case EXPORT_VALIDATION_RESULT_REQUEST:
      return {
        ...state,
        loadingExport: true
      }
    case EXPORT_VALIDATION_RESULT_SUCCESS:
      return {
        ...state,
        loadingExport: false,
        error: null
      }
    case EXPORT_VALIDATION_RESULT_FAIL:
      return {
        ...state,
        loadingExport: false,
        error: action?.payload
      }
    case LIST_EXPORT_VALIDATION_RESULT_REQUEST:
      return {
        ...state,
        loading: true
      }
    case LIST_EXPORT_VALIDATION_RESULT_SUCCESS:
      return {
        ...state,
        loading: false,
        exports: action.payload,
        error: null
      }
    case LIST_EXPORT_VALIDATION_RESULT_FAIL:
      return {
        ...state,
        loading: false,
        error: action?.payload,
        exports: action?.dummy
      }
    case DOWNLOAD_EXPORT_VALIDATION_RESULT_REQUEST:
      return {
        ...state,
        loadingDownload: true
      }
    case DOWNLOAD_EXPORT_VALIDATION_RESULT_SUCCESS:
      return {
        ...state,
        loadingDownload: false,
        error: null
      }
    case DOWNLOAD_EXPORT_VALIDATION_RESULT_FAIL:
      return {
        ...state,
        loadingDownload: false,
        error: action?.payload
      }
    case SUBMIT_ALL_EXAMINATION_RESULT_REQUEST:
      return {
        ...state,
        loadingSubmitAll: true
      }
    case SUBMIT_ALL_EXAMINATION_RESULT_SUCCESS:
      return {
        ...state,
        loadingSubmitAll: false,
        error: null
      }
    case SUBMIT_ALL_EXAMINATION_RESULT_FAIL:
      return {
        ...state,
        loadingSubmitAll: false,
        error: action?.payload
      }
    case VALIDATION_BULK_UPLOAD_FILE_REQUEST:
      return {
        ...state,
        loadingValidation: true,
        validateFileResult: []
      }
    case VALIDATION_BULK_UPLOAD_FILE_SUCCESS:
      return {
        ...state,
        loadingValidation: false,
        validateFileResult: action.payload
      }
    case VALIDATION_BULK_UPLOAD_FILE_FAIL:
      return {
        ...state,
        loadingValidation: false,
        error: action?.payload
      }
    case CANCEL_SUBMIT_ALL_EXAMINATION_RESULT_REQUEST:
      return {
        ...state,
        loadingCancelSubmitAll: true
      }
    case CANCEL_SUBMIT_ALL_EXAMINATION_RESULT_SUCCESS:
      return {
        ...state,
        loadingCancelSubmitAll: false,
        error: null
      }
    case CANCEL_SUBMIT_ALL_EXAMINATION_RESULT_FAIL:
      return {
        ...state,
        loadingCancelSubmitAll: false,
        error: action?.payload
      }
    case EXPORT_REVIEW_RESULT_REQUEST:
      return {
        ...state,
        loadingExport: true
      }
    case EXPORT_REVIEW_RESULT_SUCCESS:
      return {
        ...state,
        loadingExport: false,
        error: null
      }
    case EXPORT_REVIEW_RESULT_FAIL:
      return {
        ...state,
        loadingExport: false,
        error: action?.payload
      }

    case EXPORT_TASK_ACTIVITY_REQUEST:
      return {
        ...state,
        loadingExport: true
      }
    case EXPORT_TASK_ACTIVITY_SUCCESS:
      return {
        ...state,
        loadingExport: false,
        error: null
      }
    case EXPORT_TASK_ACTIVITY_FAIL:
      return {
        ...state,
        loadingExport: false,
        error: action?.payload
      }
    case INCLUDE_RESUME_EXAMINATION_RESULT_REQUEST:
      return {
        ...state,
        loadingIncludeResume: true
      }
    case INCLUDE_RESUME_EXAMINATION_RESULT_SUCCESS:
      return {
        ...state,
        loadingIncludeResume: false,
        error: null
      }
    case INCLUDE_RESUME_EXAMINATION_RESULT_FAIL:
      return {
        ...state,
        loadingIncludeResume: false,
        error: action?.payload
      }
    case HISTORY_LOGS_REQUEST:
      return {
        ...state,
        loadingHistoryLogs: true
      }
    case HISTORY_LOGS_SUCCESS:
      return {
        ...state,
        loadingHistoryLogs: false,
        historyLogs: action.payload,
        error: null
      }
    case HISTORY_LOGS_FAIL:
      return {
        ...state,
        loadingHistoryLogs: false,
        error: action?.payload
      }
    case UPDATE_NOTE_EXAMINATION_RESULT_REQUEST:
      return {
        ...state,
        loadingNote: true
      }
    case UPDATE_NOTE_EXAMINATION_RESULT_SUCCESS:
      return {
        ...state,
        loadingNote: false,
        error: null
      }
    case UPDATE_NOTE_EXAMINATION_RESULT_FAIL:
      return {
        ...state,
        loadingNote: false,
        error: action?.payload
      }
    
    case BULK_PUBLISH_NOT_PUBLISH_EXAMINATION_RESULT_REQUEST:
      return { ...state, loadingBulkPublishNotPublish: true }
    case BULK_PUBLISH_NOT_PUBLISH_EXAMINATION_RESULT_SUCCESS:
      return { ...state, loadingBulkPublishNotPublish: false }
    case BULK_PUBLISH_NOT_PUBLISH_EXAMINATION_RESULT_FAIL:
      return { ...state, loadingBulkPublishNotPublish: false, error: action.payload }
      
    case BULK_REFERENCE_EXAMINATION_RESULT_REQUEST:
      return { ...state, loadingBulkReference: true }
    case BULK_REFERENCE_EXAMINATION_RESULT_SUCCESS:
      return { ...state, loadingBulkReference: false }
    case BULK_REFERENCE_EXAMINATION_RESULT_FAIL:
      return { ...state, loadingBulkReference: false, error: action.payload }
    default:
      return state
  }
}

export default examinationResultReducer
